import React, { useEffect } from 'react';
import DashAdmin from './DashAdmin/DashAdmin';
import DashUser from './DashUser/DashUser';
import useAppState from './DashUser/useAppState';

const DashBoard = (props) => {
  const { state, actions } = useAppState();


  // const { state, actions } = useAppState();
  
  let userRequested= null;

  let fetchData = async () => {
    
    let userLogged = await localStorage.getItem('user') ? JSON.parse(await localStorage.getItem('user')) : props.state; 
    let tokenUserLogged = userLogged.token
    let userId =  props.adminPetition ? props.adminPetition.id : userLogged._id;
    
    userRequested = userId;
    await actions.getRegistersData(userId, tokenUserLogged)
  }

  useEffect(() => {
    fetchData();
  },['props']);







  
  // let fetchData = async () => {
    
  //   let userLogged = await localStorage.getItem('user') ? JSON.parse(await localStorage.getItem('user')) : props.state; 
  //   let tokenUserLogged = userLogged.token
  //   let userId =  props.adminPetition ? props.adminPetition.id : userLogged._id;
  //   await actions.getRegistersData(userId, tokenUserLogged)
  // }

  // props.match.params.id

  let validateUser = () => {
    if(props.location.state){
      let userLogged = props.location.state.role
      if( userLogged === "User"){
        return true;
      } else {
        return false;
      }
    } else {
      let userLogged = JSON.parse(localStorage.getItem('user'));
      if( userLogged.role === "User"){
        return true;
      } else {
        return false;
        
      }
    }
  }

  useEffect(() => {
    validateUser()
    fetchData();
  },[props])

  return state.data ? validateUser() ? <DashUser state={state} actions={actions} userRequested={state.data[0].user}/> : <DashAdmin/> : <div>Cargando...</div>
  // state={props.location.state}
  // if(validateUser()){
  //   return(
  //     <DashUser state={props.location.state}/>
  //     );
  //   } else {
  //     return(
  //       <DashAdmin />
  //   )
  // }
}

export default DashBoard;
